import { Injectable } from '@angular/core';
import { PushNotifications } from '@capacitor/push-notifications';
import { PlatformService } from '../platform/platform.service';
import { AlertService } from './../alert/alert.service';
import { HttpService } from './../http/http.service';
import { StorageService } from './../storage/storage.service';

@Injectable({
  providedIn: 'root',
})
export class FcmService {
  public static readonly DEVICE_TOKEN = 'deviceToken';

  constructor(
    private alertService: AlertService,
    private storageService: StorageService,
    private httpService: HttpService,
    private platformService: PlatformService
  ) {}

  public async initPush() {
    const deviceToken = await this.storageService.get(FcmService.DEVICE_TOKEN);
    console.log('======> Device token do storage: ', deviceToken);
    if (!deviceToken) {
      await this.registerNotifications();
    }
  }

  async addListeners() {
    await PushNotifications.addListener('registration', async (token) => {
      console.log('======> Retornou o token do Firebase: ', token.value);
      this.storageService.store(FcmService.DEVICE_TOKEN, token.value);
      await this.pushSubscribe(token.value);
      console.log('======> Token Firebase registrado com sucesso!');
    });

    await PushNotifications.addListener('registrationError', (err) => {
      console.error('Registration error: ', err.error);
    });
  }

  async registerNotifications() {
    try {
      let permStatus = await PushNotifications.checkPermissions();

      if (permStatus.receive === 'prompt') {
        permStatus = await PushNotifications.requestPermissions();
      }

      console.log('permStatus.receive', permStatus.receive);

      if (permStatus.receive !== 'granted') {
        this.alertService.showAlertOK(
          'Sem permissão!',
          'Você precisa fornecer pemissão ao Colapp para receber notificações!'
        );
      } else {
        console.log('Entrou no PushNotifications.register()', '');
        await PushNotifications.register();
        console.log('Saiu do PushNotifications.register()', '');
        await this.addListeners();
      }
    } catch (error) {
      console.log(error?.message);
    }
  }

  pushSubscribe(firebaseToken: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.httpService
        .post(`profile/push-subscribe/`, { firebaseToken })
        .subscribe(
          (res: any) => {
            if (res) {
              resolve(true);
            }
          },
          (_error: any) => {
            reject();
          }
        );
    });
  }
}
